import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

function RedirectAnnonceDetail() {
  const { annonceId } = useParams();
  return <Navigate to={`/client/my-annonces/${annonceId}`} replace />;
}

function RedirectProfessionalProfile() {
  const { professionalId } = useParams();
  return <Navigate to={`/client/professional/${professionalId}`} replace />;
}

const legacyRedirects = [
  // Old /dashboard/* → /client/*
  { path: '/dashboard/profile', element: <Navigate to="/client/profile" replace /> },
  { path: '/dashboard/requests', element: <Navigate to="/client/requests" replace /> },
  { path: '/dashboard/appointments', element: <Navigate to="/client/appointments" replace /> },
  { path: '/dashboard/messages', element: <Navigate to="/client/messages" replace /> },
  { path: '/dashboard/messages-admin', element: <Navigate to="/client/messages" replace /> },
  { path: '/dashboard/company', element: <Navigate to="/client/company" replace /> },
  { path: '/dashboard/cart', element: <Navigate to="/client/cart" replace /> },
  { path: '/dashboard/favorites', element: <Navigate to="/client/favorites" replace /> },
  { path: '/dashboard/my-purchase-requests', element: <Navigate to="/client/my-purchases" replace /> },
  { path: '/dashboard/my-annonces', element: <Navigate to="/client/my-annonces" replace /> },
  { path: '/dashboard/my-annonces/:annonceId', element: <RedirectAnnonceDetail /> },
  { path: '/dashboard/annonces', element: <Navigate to="/client/annonces" replace /> },
  { path: '/dashboard/my-responses', element: <Navigate to="/client/my-responses" replace /> },
  { path: '/dashboard/professional/:professionalId', element: <RedirectProfessionalProfile /> },
  { path: '/dashboard/settings/notifications', element: <Navigate to="/client/settings/notifications" replace /> },

  // Old /dashboard/admin/* → /admin/*
  { path: '/dashboard/admin', element: <Navigate to="/admin/dashboard" replace /> },
  { path: '/dashboard/admin/users', element: <Navigate to="/admin/users" replace /> },
  { path: '/dashboard/admin/requests', element: <Navigate to="/admin/requests" replace /> },
  { path: '/dashboard/admin/appointments', element: <Navigate to="/admin/appointments" replace /> },
  { path: '/dashboard/admin/products', element: <Navigate to="/admin/products" replace /> },
  { path: '/dashboard/admin/categories', element: <Navigate to="/admin/categories" replace /> },
  { path: '/dashboard/admin/services', element: <Navigate to="/admin/services" replace /> },
  { path: '/dashboard/admin/messages', element: <Navigate to="/admin/messages" replace /> },
  { path: '/dashboard/admin/purchase-requests', element: <Navigate to="/admin/purchase-requests" replace /> },
  { path: '/dashboard/admin/statistics', element: <Navigate to="/admin/statistics" replace /> },
  { path: '/dashboard/admin/annonces', element: <Navigate to="/admin/annonces" replace /> },
  { path: '/dashboard/admin/chatbot', element: <Navigate to="/admin/chatbot" replace /> },
  { path: '/dashboard/admin/chatbot-logs', element: <Navigate to="/admin/chatbot-logs" replace /> },
  { path: '/dashboard/admin/image-search-logs', element: <Navigate to="/admin/image-search-logs" replace /> },
  { path: '/dashboard/admin/product-interests', element: <Navigate to="/admin/product-interests" replace /> },
  { path: '/dashboard/admin/site-mode', element: <Navigate to="/admin/site-mode" replace /> },
  { path: '/dashboard/admin/pro-registrations', element: <Navigate to="/admin/pro-registrations" replace /> },
  { path: '/dashboard/admin/contacts', element: <Navigate to="/admin/contacts" replace /> },
  { path: '/dashboard/admin/import-products', element: <Navigate to="/admin/import-products" replace /> },
  { path: '/dashboard/admin/import-ia', element: <Navigate to="/admin/import-ia" replace /> },
  { path: '/dashboard/admin/seller-requests', element: <Navigate to="/admin/seller-requests" replace /> },
  {
    path: '/dashboard/admin/seller-requests/:requestId',
    element: <Navigate to="/admin/seller-requests/:requestId" replace />,
  },
  { path: '/dashboard/admin/search-analytics', element: <Navigate to="/admin/search-analytics" replace /> },
  { path: '/dashboard/admin/analytics', element: <Navigate to="/admin/analytics" replace /> },
  { path: '/dashboard/admin/logs', element: <Navigate to="/admin/logs" replace /> },
  { path: '/dashboard/admin/database', element: <Navigate to="/admin/database" replace /> },
  { path: '/dashboard/admin/launch-notifications', element: <Navigate to="/admin/launch-notifications" replace /> },
  { path: '/dashboard/admin/landing', element: <Navigate to="/admin/landing" replace /> },
];

export default legacyRedirects;
